import styled from "styled-components";
import InstrumentInformationsWrapper from "../instrument-informations-dialog/instrument-informations-context/InstrumentInformationsWrapper";
import HistoryItemWrapper from "../log-book-history-item/HistoryItemWrapper";
import ItemCoverSheetWrapper from "../log-book-item-cover-sheet-dialog/cover-sheet-context/ItemCoverSheetWrapper";
import ItemWrapper from "../log-book-item-form-dialog/item-context/ItemWrapper";
import ItemFormDialog from "../log-book-item-form-dialog/ItemFormDialog";
import LogBookList from "../log-book-table/LogBookList";
import ClusterItemFormDialog from "../log-book-item-form-dialog/ClusterItemFormDialog";
import { entryType, formTypes, LOGBOOK_ATTACHMENTS } from "../../../constants";
import { emptyLogSheetCluster } from "../log-sheet/log-sheet-form/empty-log-sheet";
import { logSheetClusterValidationSchemaFactory } from "../log-sheet/log-sheet-form/log-sheet-validation-schema";
import { CreateLogSheetChangeCluster } from "../log-sheet/log-sheet-form/CreateLogSheetChange";
import { emptyRunLogCluster } from "../run-logs/run-logs-form/empty-run-log";
import { CreateRunLogChangeCluster } from "../run-logs/run-logs-form/CreateRunLogChange";
import RunLogClusterTableMeta from "../run-logs/runLogs-table/RunLogClusterTableMeta";
import { AttachmentDocs, configurationDetailsField } from "../log-sheet/log-sheet-table/LogSheetTableMeta";
import { RunLogAttachmentDocs } from "../run-logs/runLogs-table/RunLogTableMeta";
import LogSheetClusterTableMeta from "../log-sheet/log-sheet-table/LogSheetClusterTableMeta";
import ClusterItemSubComponentDialog from "../log-book-item-form-dialog/ClusterItemSubComponentDialog";
import {
  actionHeadingDetailCell,
  runHeadingDetailCell,
  SubComponent
} from "../common-for-log-sheet-and-run-logs/HistoryCommonCellsInfo";
import { useContext, useState } from "react";
import { CoverSheetMainPageContext } from "../../cover-sheet/cover-sheet-main-page-context/context";
import { runLogClusterValidationSchemaFactory } from "../run-logs/run-logs-form/run-log-validation-schema";
import AllLogClusterTableMeta from "../run-logs/runLogs-table/AllLogClusterTableMeta";
import ACTION_LOGS_DATA_MODEL from "../../../utils/constants/actionLogsDataModel";

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
`;


const ItemPage = ({
  addButtonLabel,
  queryName,
  importFn,
  CellsInfoArray,
  title,
  dataTestId,
  type,
  fetchingFn,
  orderBy,
  meta,
  emptyItem,
  cleanItemFn,
  createItemChangeFn,
  validationSchemaFactory,
  selectSuggestionFn,
  clearSuggestionFn,
  showChipBox,
  addNewDialogButtonLabel,
  children,
  equipmentDetail
}) => {
  const [clusterLogStatus, setClusterLogStatus] = useState(false);
  const { isClusterForm, allLogType } = useContext(CoverSheetMainPageContext);
  const disableStatus = equipmentDetail?.entryType === entryType.clusterSubequipment;

  if (!CellsInfoArray.includes(SubComponent)) {
    /* Adding Subcomponent for audit trail for Cluster log*/
    if (type === formTypes.RUN_LOG) {
      CellsInfoArray.unshift(runHeadingDetailCell);
    } else {
      CellsInfoArray.unshift(actionHeadingDetailCell);
    }
    CellsInfoArray.unshift(SubComponent);
  }

  if (
    !AllLogClusterTableMeta.expandedComponentProps.actionInfoMeta.fields.some(
      (el) => el.lookapVal === LOGBOOK_ATTACHMENTS.ATTACHMENTS
    )
  ) {
    AllLogClusterTableMeta.expandedComponentProps.actionInfoMeta.fields.push(AttachmentDocs);
  }

  if (
    !RunLogClusterTableMeta.expandedComponentProps.infoMeta.fields.some(
      (el) => el.lookapVal === LOGBOOK_ATTACHMENTS.ATTACHMENTS
    )
  ) {
    RunLogClusterTableMeta.expandedComponentProps.infoMeta.fields.push(RunLogAttachmentDocs);
  }

  if (
    Boolean(equipmentDetail) &&
    equipmentDetail?.entryType !== entryType.cluster &&
    !AllLogClusterTableMeta.expandedComponentProps.actionInfoMeta.fields.some(
      (el) => el.label === ACTION_LOGS_DATA_MODEL.configurationDetails.value
    )
  ) {
    AllLogClusterTableMeta.expandedComponentProps.actionInfoMeta.fields.push(configurationDetailsField);
  }

  return (
    <ItemCoverSheetWrapper>
      <ItemWrapper entryDataType={equipmentDetail?.entryType} setClusterLogStatus={setClusterLogStatus}>
        <InstrumentInformationsWrapper addButtonLabel={addButtonLabel}>
          <HistoryItemWrapper
            queryName={queryName}
            importFn={importFn}
            CellsInfoArray={CellsInfoArray}
            title={title}
            dataTestId={dataTestId}
            addButtonLabel={addButtonLabel}
            disableStatus={disableStatus}
            type={type}
          >
            {equipmentDetail?.entryType === entryType.cluster ||
            equipmentDetail?.entryType === entryType.clusterSubequipment ? (
              <LogBookList
                dataTestId={`${dataTestId}-table`}
                meta={
                  type === formTypes.RUN_LOG
                    ? RunLogClusterTableMeta
                    : type === formTypes.ACTION_LOG
                    ? LogSheetClusterTableMeta
                    : AllLogClusterTableMeta
                }
                fetchingFn={fetchingFn}
                clusterLogStatus={clusterLogStatus}
                type={type}
              />
            ) : (
              <LogBookList
                dataTestId={`${dataTestId}-table`}
                orderBy={orderBy}
                meta={type === formTypes.ALL_LOG ? AllLogClusterTableMeta : meta}
                fetchingFn={fetchingFn}
                disableStatus={disableStatus}
                type={type}
              />
            )}
          </HistoryItemWrapper>
        </InstrumentInformationsWrapper>
        {!isClusterForm && (
          <ItemFormDialog
            addNewDialogButtonLabel={addNewDialogButtonLabel}
            emptyItem={emptyItem}
            cleanItemFn={cleanItemFn}
            createItemChangeFn={createItemChangeFn}
            validationSchemaFactory={validationSchemaFactory}
            dataTestId={dataTestId}
            selectSuggestionFn={selectSuggestionFn}
            clearSuggestionFn={clearSuggestionFn}
            type={type}
            showChipBox={showChipBox}
            equipmentDetail={equipmentDetail}
          >
            {children}
          </ItemFormDialog>
        )}
        {isClusterForm && (
          <ClusterItemFormDialog
            addNewDialogButtonLabel={addNewDialogButtonLabel}
            emptyItem={
              type === formTypes.RUN_LOG
                ? emptyRunLogCluster
                : type === formTypes.ALL_LOG
                ? allLogType === formTypes.RUN_LOG
                  ? emptyRunLogCluster
                  : emptyLogSheetCluster
                : emptyLogSheetCluster
            }
            cleanItemFn={cleanItemFn}
            createItemChangeFn={
              type === formTypes.RUN_LOG
                ? CreateRunLogChangeCluster
                : type === formTypes.ALL_LOG
                ? allLogType === formTypes.RUN_LOG
                  ? CreateRunLogChangeCluster
                  : CreateLogSheetChangeCluster
                : CreateLogSheetChangeCluster
            }
            validationSchemaFactory={
              type === formTypes.RUN_LOG
                ? runLogClusterValidationSchemaFactory
                : type === formTypes.ALL_LOG
                ? allLogType === formTypes.RUN_LOG
                  ? runLogClusterValidationSchemaFactory
                  : logSheetClusterValidationSchemaFactory
                : logSheetClusterValidationSchemaFactory
            }
            dataTestId={dataTestId}
            selectSuggestionFn={selectSuggestionFn}
            clearSuggestionFn={clearSuggestionFn}
            type={type === formTypes.ALL_LOG ? allLogType : type}
            showChipBox={showChipBox}
            equipmentDetail={equipmentDetail}
            setClusterLogStatus={setClusterLogStatus}
          />
        )}
        <ClusterItemSubComponentDialog equipmentDetail={equipmentDetail} />
      </ItemWrapper>
    </ItemCoverSheetWrapper>
  );
};

export default ItemPage;
